import { Component } from 'preact';
import { TEXT_BODY, ACCENT_GOLD, DARK_BASE } from '../lib/medievalTheme';
import { t } from '../localization/t';

// Full-viewport gate rendered INSTEAD of the app (see main.jsx) when the
// browser build runs on a touch device smaller than the 13-inch iPad Pro
// class (isUnsupportedScreen in utils/platform.js). Rendered outside
// AppStage, so cqw units don't resolve here; sizes are plain px/vw.
export default class UnsupportedScreen extends Component {
  render() {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: DARK_BASE,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '0 24px',
          gap: '14px',
        }}
      >
        <div
          className="arena-heading"
          style={{ color: ACCENT_GOLD, fontSize: 'clamp(26px, 6vw, 40px)' }}
        >
          Valkenhall
        </div>
        <div
          style={{
            color: TEXT_BODY,
            fontSize: 'clamp(14px, 2.4vw, 17px)',
            lineHeight: 1.5,
            maxWidth: '30em',
          }}
        >
          {t('Screen size not supported.')}
        </div>
        <a
          href="https://valkenhall.com"
          style={{
            color: ACCENT_GOLD,
            fontSize: 'clamp(13px, 2.2vw, 15px)',
            textDecoration: 'underline',
          }}
        >
          valkenhall.com
        </a>
      </div>
    );
  }
}
